import { HorizonInterval } from '../Horizon';
import { AnyObject } from 'final-form';

export default class CreateHorizonDto {
    horizonInterval: HorizonInterval;
    sequence: Array<{ id: number; sequence: number }>;
    currentHorizonId: number;
    copyData: boolean;
    copyHorizonId: string;
    copyOwnership: boolean;
    copyLeasehold: boolean;
    copyWorkingInterest: boolean;
    copyOverridingRoyaltyInterest: boolean;
    isChildTract: boolean;
    tractId?: number;

    public static from(values: AnyObject) {
        const createHorizonDto = new CreateHorizonDto();
        createHorizonDto.horizonInterval = HorizonInterval.from(values.addHorizon);
        createHorizonDto.sequence = values.sequencing.map((hor: HorizonInterval) => ({ id: hor.id, sequence: hor.sequencePosition }));

        return createHorizonDto;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/CreateHorizonDto.ts